"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterType = void 0;
var RegisterType;
(function (RegisterType) {
    RegisterType["LEVERING_NORMAAL"] = "Levering Normaal";
    RegisterType["LEVERING_LAAG"] = "Levering Laag";
    RegisterType["TERUGLEVERING_NORMAAL"] = "Teruglevering Normaal";
    RegisterType["TERUGLEVERING_LAAG"] = "Teruglevering Laag";
    RegisterType["LEVERING_GAS"] = "Levering Gas";
})(RegisterType = exports.RegisterType || (exports.RegisterType = {}));
